import React from "react";
import CloudImage from "../CloudImage/CloudImage";

import { Link } from "react-router-dom";

const ServiceSection3 = (props) => {
  return (
    <section className="wpo-about-section alfa-section section-padding">
      <div className="container">
        <div className="row align-items-center justify-content-between d-none d-lg-flex">
          <div className="col-lg-6">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img">
                <CloudImage
                  publicId="curso-alfabetizacao-emocional_asnakn"
                  alt="E-books"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="wpo-about-text">
              <h2>Bônus Exclusivo</h2>
              <p className="sub-text">
                Transforme birras em diálogo e frustração em resiliência. Com
                nosso curso, seu filho aprenderá a gerenciar as emoções,
                resultando em mais foco, menos ansiedade e um desenvolvimento
                muito mais saudável.
              </p>
              <ul>
                <li>
                  <i className="ti-check"></i>Dê ao seu filho as ferramentas
                  para lidar com a frustração e a ansiedade, abrindo caminho
                  para o sucesso escolar e pessoal.
                </li>
                <li>
                  <i className="ti-check"></i>A inteligência emocional é a base
                  para relacionamentos saudáveis e uma vida adulta equilibrada.
                  Comece a construir esse alicerce agora.
                </li>
              </ul>
              <Link onClick={props.link} className="theme-btn">
                GARANTIR MEU BÔNUS AGORA
              </Link>
            </div>
          </div>
        </div>

        <div className="d-lg-none text-center">
          <div className="wpo-about-text">
            <h2>Bônus Exclusivo</h2>

            <p className="sub-text">
              Transforme birras em diálogo e frustração em resiliência. Com
              nosso curso, seu filho aprenderá a dominar as emoções, resultando
              em mais foco, menos ansiedade e um desenvolvimento muito mais
              saudável.
            </p>
            <ul>
              <li>
                <i className="ti-check"></i>
                Dê ao seu filho
                as ferramentas para lidar com a frustração e a ansiedade, abrindo
                caminho para o sucesso escolar e pessoal.
              </li>
              <li>
                <i className="ti-check"></i>
                A inteligência emocional é a base
                para relacionamentos saudáveis e uma vida adulta equilibrada.
                Comece a construir esse alicerce agora.
              </li>
            </ul>
          </div>
          <div className="wpo-about-wrap mt-4 mb-4">
            <div className="wpo-about-img">
              <CloudImage
                publicId="curso-alfabetizacao-emocional_asnakn"
                alt="E-books"
              />
            </div>
          </div>
          <Link onClick={props.link} className="theme-btn">
            QUERO MEU KIT COMPLETO AGORA
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection3;
